import React from 'react';
import { connect } from 'react-redux';
import { StartSessionForm, AddParticipantForm } from './index';

import PhotoBoothModal from '../../../../../../../containers/PhotoBoothModal';
import { EMPTY_PARTICIPANT, setParticipant } from '../../../data/fileImport/participantActions';

class StartSessionModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      quickParticipantOpened: false
    };

    this.addQuickParticipant = this.addQuickParticipant.bind(this);
    this.resetValues = this.resetValues.bind(this);
    this.submitAddParticipantForm = this.submitAddParticipantForm.bind(this);
    this.cancelAddParticipantForm = this.cancelAddParticipantForm.bind(this);
  }

  addQuickParticipant() {
    this.setState({
      quickParticipantOpened: true
    });
  }

  closeAddParticipantForm() {
    this.setState({
      quickParticipantOpened: false
    });
  }

  resetValues() {
    this.closeAddParticipantForm();

    this.props.dispatch(setParticipant(EMPTY_PARTICIPANT));
    this.props.onRequestClose();
  }

  submitAddParticipantForm(participant) {
    this.closeAddParticipantForm();

    this.props.dispatch(setParticipant(participant));
  }

  cancelAddParticipantForm() {
    this.closeAddParticipantForm();
  }

  render() {
    return (
      <PhotoBoothModal {...this.props} onRequestClose={this.resetValues}>
        <h3 className="modal-title">Start Session</h3>

        {this.state.quickParticipantOpened ? (
          <AddParticipantForm
            quickParticipantOpened={this.state.quickParticipantOpened}
            submitAddParticipantForm={this.submitAddParticipantForm}
            cancelAddParticipantForm={this.cancelAddParticipantForm}
          />
        ) : (
          ''
        )}
        <StartSessionForm
          quickParticipantOpened={this.state.quickParticipantOpened}
          openAddParticipantForm={() => {
            this.addQuickParticipant();
          }}
        />
      </PhotoBoothModal>
    );
  }
}

export default connect(state => ({
  participant: state.projects.single.fileImport.participant
}))(StartSessionModal);



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/fileImport/modals/StartSessionModal.js